import React, { useState, useEffect } from "react";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { Accordion, Button, Col, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { saveProductMapping } from "../../store/slices/saveProductMapping";
import { createcategoriescatalog } from "../../store/slices/createPreExistingCategories";
import {syncStatus} from "../../store/slices/syncStatus"
import { getConfig } from "../../store/slices/getConfig";
import { useDispatch } from "react-redux"; 
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


function CollectionCatlog_configuration({changeTab}) {
  const configId = useSelector((state) => state.saveCreds.configId);
  const domain = useSelector((state)=> state.config.data.targetClientDomain);
  const savedData = useSelector((state) => state.config.data);
  const preExistingcategoriesStatus = useSelector(state => state.preExistingCategoriesCatlog);
  const dispatch = useDispatch();
  const [showMsg, setShowMsg] = useState(false);


  const handleSubmit = async (e) => {
  e.preventDefault();

  const storeDomain = savedData?.targetClientDomain;
  if (!storeDomain) return;

    try {
      // 1️⃣ First API
      await dispatch(createcategoriescatalog({ storeDomain })).unwrap();

      await dispatch(syncStatus(savedData?.struConfigId)).then((action)=>{

        const isDedup = action.payload?.data?.data?.result?.[0]?.isDedupeExist
        var req;
        if(isDedup && isDedup == "true"){
        req = {
          attributeMapping: {
            ...savedData?.attributeMapping,
            isPreExistingCategoriesCompleted: "CompletedWithDedup",
            isPreExistingProductCompleted:  savedData?.attributeMapping?.isPreExistingProductCompleted || "null",
          },
          struConfigId: configId || savedData?.struConfigId,
        };
      }else{
        req = {
          attributeMapping: {
            ...savedData?.attributeMapping,
            isPreExistingCategoriesCompleted: "Completed",
            isPreExistingProductCompleted: savedData?.attributeMapping?.isPreExistingProductCompleted || "null",
          },
          struConfigId: configId || savedData?.struConfigId,
        };
      }

        dispatch(saveProductMapping(req)).unwrap();
      
  })

      // 3️⃣ Third API
      await dispatch(getConfig(domain)).unwrap();

    } catch (error) {
    }
  };


  const monitorStatus = () => {
    if (savedData !== null) {
      dispatch(syncStatus(savedData?.struConfigId));
    }
    changeTab("sync-status")
  }

  useEffect(() => {
    if ((savedData?.attributeMapping?.isPreExistingCategoriesCompleted === "Completed" || savedData?.attributeMapping?.isPreExistingCategoriesCompleted === "CompletedWithDedup" || savedData?.attributeMapping?.isPreExistingCategoriesCompleted === "null") && preExistingcategoriesStatus?.status == "SUCCESS") {
      setShowMsg(true);

      const timer = setTimeout(() => {
        setShowMsg(false);
      }, 60000); // 10 sec

      return () => clearTimeout(timer); // cleanup
    }
  }, [preExistingcategoriesStatus?.status]);

    

  return (
    <div className="mt-4">
      <Form onSubmit={handleSubmit}>
        <Accordion.Item eventKey="3" className="my-1">
          <Accordion.Header>
            Pre-existing Collection Mapping (optional)
          </Accordion.Header>
          <Accordion.Body className="p-4">
            <div className="bg-light p-4 rounded">
              <Row className="border-bottom pb-3 mb-3 align-items-center">
                <Col sm={12}>
                  <h6 className="fw-bold m-0">
                    Pre-existing Collections
                  </h6>
                </Col>
              </Row>
              <Row>
                <Col sm={5}>
                  <h6 className="fw-bold mb-4">Shopify Collection Identifier</h6>
                </Col>
                <Col sm={5} className="mx-5">
                  <h6 className="fw-bold mb-4 ms-5">PIM Category Identifier</h6>
                </Col>
              </Row>

              <Row>
                <Col sm={5}>
                  <Form.Group controlId="s_collection_identifier">
                    <Form.Control
                      value="Title"
                      readOnly
                    />
                  </Form.Group>
                </Col>

                <Col
                  sm={1}
                  className="d-flex justify-content-center compareIcon"
                >
                  <CompareArrowsIcon className="mt-2" />
                </Col>

                <Col sm={5}>
                  <Form.Group controlId="s_collection_identifier">
                    <Form.Control
                      value="Label"
                      readOnly
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className="infoIcon">
                <InfoOutlinedIcon fontSize="30px"/>
                <p className="custom-field-note ms-2 mt-3 ml-0 fs-13">
                  Identifiers for Collection & Categories will be auto selected to Collection "Title" and Category "Label" accordingly.
                </p>
              </div>
            </div>
           <Row className="mt-5 mx-3">
              <Col sm={12}>
                <Button variant="primary"
                  type="submit"
                  className="stru-btn" 
                  disabled= {savedData?.attributeMapping?.isPreExistingCategoriesCompleted == "Completed" || savedData?.attributeMapping?.isPreExistingCategoriesCompleted === "CompletedWithDedup"}
                  >
                    {preExistingcategoriesStatus?.status == "Inprogress" && <div className="spinner-border me-2" role="status" style={{ width: "18px", height: "18px" }}>
                    <span className="visually-hidden">Loading...</span>
                    </div>}
                  Generate Mapping
                </Button>
                {preExistingcategoriesStatus?.status == "Inprogress" &&<>
                  <div className="infoIcon">
                    <InfoOutlinedIcon fontSize="30px" style={{fill:"red"}}/>
                    <p className="custom-field-note ms-2 mt-3 text-danger fs-13">
                      Mapping generation in progress, this activity may takes a few minutes
                    </p>
                    </div>
                    <Button
                      type="button"
                      variant="primary"
                      className="job-link p-0 ms-2"
                      onClick={() => monitorStatus()}
                    >
                      <span
                        style={{
                          color: "#000",
                          textDecoration:"underline"
                        }}
                        className="fs-13"
                      >
                      Check your sync job status.
                      </span>
                    </Button>
                    </>
                }
                {showMsg &&<>
                    <br />
                    <Button
                      type="button"
                      variant="primary"
                      className="job-link p-0 ms-2 mt-2"
                      onClick={() => monitorStatus()}
                    >
                      <span
                      className="fs-13"
                        style={{
                          color: "#000",
                          textDecoration:"underline"
                        }}
                      >
                      Check your sync job status.
                      </span>
                    </Button>
                    </>
                }
                {(savedData?.attributeMapping?.isPreExistingCategoriesCompleted == "Completed") ?
                    <div className="infoIcon">
                      <InfoOutlinedIcon fontSize="30px"/>
                        <p className="custom-field-note ms-2 mt-3 fs-13">
                           Mapping has been generated already. Contact StrikeTru to re-generate Mapping
                        </p>
                    </div> : (savedData?.attributeMapping?.isPreExistingCategoriesCompleted === "CompletedWithDedup") ?
                    <div className="infoIcon">
                      <InfoOutlinedIcon fontSize="30px"/>
                        <p className="custom-field-note ms-2 mt-3 fs-13">
                           Duplicate collections found, if you want to retain duplicate collections, please contact us.
                        </p>
                    </div>
                    :
                    <div className="infoIcon">
                      <InfoOutlinedIcon fontSize="30px"/>
                      <p className="custom-field-note ms-2 mt-3 fs-13">
                        This allows you to link pre-existing shopify Collections to the equivalent categories in PIM. Collection mapping can only be generated once.
                      </p>
                    </div>
                }
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Form>
    </div>
  );
}

export default CollectionCatlog_configuration;
